import React, { Component } from "react"

import { Card, CardBody, Col, Row } from "reactstrap"

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css"
import LiVerticalTimeLine from "./LiVerticalTimeLine"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { deleteOfferHistory, getOfferById, setOfferHistoryItem, updateOffer } from "../../../store/offers/actions";
import OfferInfoForm from "../../../components/forms/OfferInfoForm/OfferInfoForm"
import { withRouter } from "react-router-dom";

class OfferHistory extends Component {

  onClickItem = item => {
    if (item?.id === this.props.offer?.id) {
      this.props.toggle("profile");
      return void 0;
    }

    this.props.history.push(`/offers/${item.id}?history=true`)

    item?.id && this.props.getOfferById(item.id)
  }

  onExit = () => this.props.setOfferHistoryItem(null)

  formSubmit = data => {
    data.applications = [data.applications]
    this.props.updateOffer(this.props.history_item?.id, data)
    this.onExit()
  }


  render() {
    const { history_item } = this.props
    console.log({history_props: this.props })
    return (
      <React.Fragment>
        {!history_item
          ? <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <h4 className="card-title mb-3">Cost history</h4>
                  {this.props.data?.length !== 0 ? (
                    <Row className="mt-2">
                      <Col lg={6}>
                        <div className="mb-3">
                          <ul className="verti-timeline list-unstyled">
                            {this.props.data?.map((history, key) => (
                              <LiVerticalTimeLine
                                history={history}
                                key={"_history_" + history.id}
                                isLast={this.props.data.length === key + 1}
                                onClick={this.onClickItem}
                                onDelete={this.props.data.length > 1 ? this.props.deleteOfferHistory : null}
                              />
                            ))}
                          </ul>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <Row className="align-items-center text-center mt-4">
                      <Col xs={12}>
                        <i
                          className="dripicons-archive"
                          style={{ fontSize: "130px", opacity: "0.2" }}
                        />
                        <p style={{ opacity: "0.2" }}>No cost history...</p>
                      </Col>
                    </Row>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          : <OfferInfoForm
            onSubmit={this.formSubmit}
            client_id={this.props.history_item?.client_id}
            offer={this.props.history_item}
            isHistory
            onExit={this.onExit}
            readOnly={!this.props.permissions["change_appoffermodel"]}
          />}
      </React.Fragment>
    )
  }
}

OfferHistory.propTypes = {
  data: PropTypes.any,
  history_item: PropTypes.any,
  getOfferById: PropTypes.func,
  setOfferHistoryItem: PropTypes.func,
  updateOffer: PropTypes.func,
  toggle: PropTypes.func,
  offer: PropTypes.any,
  deleteOfferHistory: PropTypes.func,
  history: PropTypes.any,
  permissions: PropTypes.any,
}

const mapStateToProps = state => ({
  data: state.Offers.historyData,
  history_item: state.Offers.history_item,
  offer: state.Offers.offer,
  permissions: state.User.permissions,
})

export default connect(mapStateToProps, {
  deleteOfferHistory,
  getOfferById,
  setOfferHistoryItem,
  updateOffer
})(withRouter(OfferHistory))
